<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminReturns/">Returns</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role === 'DEMO_ACCOUNT'"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role === 'DEMO_ACCOUNT'"><a
        routerLink="/admin/returns/">Returns</a></li>
      <li class="breadcrumb-item active" aria-current="page">Process Return Order</li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <div class="row align-items-center">
        <div class="col-6">
        </div>
        <div class="col-md-6 mt-4 mt-md-0 text-right float-right">
          <a *ngIf="user.role === 'ROLE_ADMIN'" routerLink="/admin/adminOrder"
             class="text-danger p-2 ml-2"><b>Discard</b></a>
          <a *ngIf="user.role === 'WORK_MEN'" routerLink="/admin/workMenOrder"
             class="text-danger p-2 ml-2"><b>Discard</b></a>
          <button class="btn btn-orange text-white p-2 ml-2" *ngIf="step == 2" (click)="submitOrderForShipment()"><b>Submit</b></button>
        </div>
      </div>
    </div>
  </div>

  <form *ngIf="step == 1">
    <div class="row">
      <div class="col">
        <div class="inner-box">
          <h5 class="text-black mb-3">Order Details</h5>
          <div class="row mt-3">
            <div class="col-4">
              <label class="mb-1 control-label"><b>Order Number</b> : {{reviewOrder.orderNumber}}</label><br>
              <label class="mb-1 control-label"><b>Status</b> : {{reviewOrder.orderStatus}}</label><br>
              <label class="mb-1 control-label"><b>Connection Name</b> : {{reviewOrder.connectionName}}</label>
            </div>
            <div class="col-4">
              <label  class="mb-1 control-label"><b>Sender Name</b> : {{reviewOrder.senderName}}</label><br>
              <label  class="mb-1 control-label"><b>Company Name</b> : {{reviewOrder.senderCompanyName}}</label><br>
              <label  class="mb-1 control-label"><b>Phone No </b> : {{reviewOrder.senderMobile}}</label><br>
              <label  class="mb-1 control-label"><b>Email</b> : {{reviewOrder.senderEmail}}</label><br>
              <label  class="mb-1 control-label"><b>Address</b> : {{reviewOrder.senderAddressText}}</label>
            </div>
            <div class="col-4">
              <label  class="mb-1 control-label"><b>Receiver Name</b> : {{reviewOrder.receiverName}}</label><br>
              <label  class="mb-1 control-label"><b>Company Name</b> : {{reviewOrder.receiverCompanyName}}</label><br>
              <label  class="mb-1 control-label"><b>Phone No </b> : {{reviewOrder.receiverMobile}}</label><br>
              <label  class="mb-1 control-label"><b>Email</b> : {{reviewOrder.receiverEmail}}</label><br>
              <label  class="mb-1 control-label"><b>Address</b> : {{reviewOrder.receiverAddressText}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <form *ngIf="step == 1">
    <div class="col">
      <ul class="list-inline tab-list">
        <li class="list-inline-item ml-2"><a class="list-inline-item" (click)=" tabChange('packing');"
                                             [ngClass]="{'active': tabClicked === 'packing'}">Returned Product
        </a></li>
        <li class="list-inline-item ml-3"><a class="nav-link warehouses" (click)=" tabChange('carrier');"
                                             [ngClass]="{'active': tabClicked === 'carrier'}">Shipping Options</a>
        </li>
      </ul>
    </div>

    <div class="inner-box">
    <div *ngIf="tabClicked === 'packing'">
      <!--<div class="row">
        <div class="col">
          <div class="inner-box">
            <h2 class="text-black mb-3">Select the Package Type</h2>
            <h6 class="text-black mb-3">How is your inventory configured?</h6>
            <div class="row">
              <div class="col-md-6">
                <div class="form-radio">
                  <input type="radio" name="skuConfig" id="SingleSKU" [(ngModel)]="productConfig"
                         (change)="change()" [ngModelOptions]="{standalone: true}" value="SKU" required checked/>
                  <label for="SingleSKU">One SKU per box
                    <p class="label-para-size">Each box contains a single SKU</p>
                  </label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-radio">
                  <input type="radio" name="skuConfig" id="multipleSKU" [(ngModel)]="productConfig"
                         (change)="change()" [ngModelOptions]="{standalone: true}" value="MULTI_SKU" required>
                  <label for="multipleSKU">Multiple SKUs per box
                    <p class="label-para-size">Each box has 2 or more SKUs</p>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3" *ngIf="productConfig === 'SKU' || productConfig === 'MULTI_SKU'">
        <div class="col">
          <div class="inner-box">
            <h2 class="text-black mb-3">Packing Configuration</h2>
            <div class="row mt-4">
              <div class="col-md-12" style="overflow-x:auto" *ngIf="productConfig === 'SKU'">
                <table class="table packing-table packing-table-2" style="line-height:1.5">
                  <thead class="thead-light">
                  <tr>
                    <th>Product <br> SKU</th>
                    <th>Quantity</th>
                    <th>Quantity/Box</th>
                    <th>No.of Boxes</th>
                    <th style="width: 200px">Package Type <br> Box Dimensions (in cm)</th>
                    <th>Weight (in kg)</th>
                    <th>Total Weight (in kg)</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <ng-container *ngFor="let o of reviewOrder.lines">
                    <tr *ngIf="!showAddShipRow(o)">
                      <td class="align-top"
                          [attr.rowspan]="(!o.shipLines?.length ? 1 : o.shipLines?.length)"
                          style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 300px;">
                        {{o.productName}} <br> {{o.sku}}
                      </td>
                      <td class="align-top"
                          [attr.rowspan]="(!o.shipLines?.length ? 1 : o.shipLines?.length)">{{o.quantity}} <img
                        src="/./assets/images/tick.svg" class="float-right" title="Shipment quantity is mathced"
                        style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="showShipIcon(o)"> <img
                        src="/./assets/images/close.svg" class="float-right" title="Shipment quantity is not mathced"
                        style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;"
                        *ngIf="!showShipIcon(o) &&( o.qtyPerBoxTmp || o.numOfBoxesTmp || o.shipLines.length>1)"></td>
                      <td class="bg-color2"><input type="text" [disabled]="showAddShipRow(o)" class="form-control"
                                                   (change)="populateDimensions(o)" [(ngModel)]="o.qtyPerBoxTmp"
                                                   onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                   [ngModelOptions]="{standalone: true}" required></td>
                      <td class="bg-color2"><input type="text" [disabled]="showAddShipRow(o)" class="form-control"
                                                   (change)="populateDimensions(o);totalWeightCal()"
                                                   [(ngModel)]="o.numOfBoxesTmp"
                                                   onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                   [ngModelOptions]="{standalone: true}" required></td>
                      <td class="bg-color2" style="width: 200px">
                        <ng-select id="package" [(ngModel)]="o.packageType" [disabled]="showAddShipRow(o)" appendTo="body"
                                   (open)="openPackage()" (change)="populateDimensions(o)"
                                   [ngModelOptions]="{standalone: true}" required
                                   [items]="package"
                                   bindLabel="packingType"
                                   bindValue="packingType"
                                   placeholder="Package Type">
                        </ng-select>
                        <div class="ml-1 mt-2">
                          <input type="text" style="width: 50px !important" [disabled]="o.packageType !== 'Custom'"
                                 [(ngModel)]="o.boxLength"
                                 [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline"
                                 placeholder="L"/>

                          <input type="text" style="width: 50px !important" [disabled]="o.packageType !== 'Custom'"
                                 [(ngModel)]="o.boxWidth"
                                 [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline"
                                 placeholder="W"/>

                          <input type="text" style="width: 50px !important" [disabled]="o.packageType !== 'Custom'"
                                 [(ngModel)]="o.boxHeight"
                                 [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline"
                                 placeholder="H"/>
                        </div>
                      </td>
                      <td class="bg-color2"><input type="text" [(ngModel)]="o.quantityWeight" appOnlyNumbers
                                                   class="form-control"
                                                   [ngModelOptions]="{standalone: true}" (change)="totalWeightCal()"
                                                   required>
                      </td>
                      <td>
                        <input disabled [(ngModel)]="o.totalWeight" [ngModelOptions]="{standalone: true}"
                               class="form-control  width-120" required/>
                      </td>
                      <td class="align-middle bg-color2">
                        <a (click)="addShipmentLine(o)" *ngIf="showAddShipmentBtn(o) " data-toggle="tooltip"
                           data-placement="top" title="Add">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21.34" height="21.34" viewBox="0 0 21.34 21.34">
                            <path id="Icon_ionic-md-add-circle" data-name="Icon ionic-md-add-circle"
                                  d="M14.045,3.375a10.67,10.67,0,1,0,10.67,10.67A10.67,10.67,0,0,0,14.045,3.375Zm5.489,11.747H15.122v4.412H12.968V15.122H8.556V12.968h4.412V8.556h2.155v4.412h4.412Z"
                                  transform="translate(-3.375 -3.375)" fill="#ee7125"/>
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <ng-container *ngFor="let s of o?.shipLines; let j=index;">
                      <tr *ngIf="o?.shipLines?.length && j!==0">
                        <td class="align-top" *ngIf="showAddShipRow(o) && j==1"
                            [attr.rowspan]="(!o.shipLines?.length ? 1 : ((o.shipLines?.length && !showAddShipRow(o))? o.shipLines?.length:o.shipLines?.length-1 ))">
                          {{o.productName}}
                        </td>
                        <td class="align-top" *ngIf="showAddShipRow(o) && j==1"
                            [attr.rowspan]="(!o.shipLines?.length ? 1 : ((o.shipLines?.length && !showAddShipRow(o))? o.shipLines?.length:o.shipLines?.length-1 ))">
                          {{o.quantity}}
                          <img src="/./assets/images/tick.svg" class="float-right" title="Shipment quantity is mathced"
                               style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="showAddShipRow(o)"> <img
                          src="/./assets/images/close.svg" class="float-right" title="Shipment quantity is not mathced"
                          style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="!showAddShipRow(o)"></td>
                        <td><input type="text" disabled [(ngModel)]="s.quantityPerBox"
                                   onkeypress='return event.charCode >= 48 && event.charCode <= 57' class="form-control"
                                   [ngModelOptions]="{standalone: true}" required></td>
                        <td><input type="text" disabled [(ngModel)]="s.numberOfBoxes"
                                   onkeypress='return event.charCode >= 48 && event.charCode <= 57' class="form-control"
                                   [ngModelOptions]="{standalone: true}" required></td>
                        <td><input type="text" disabled [(ngModel)]="s.packageType" class="form-control w-100"
                                   [ngModelOptions]="{standalone: true}" required>
                          <div class="mt-2 ml-1">
                            <input type="text" style="width: 50px !important" disabled [(ngModel)]="s.boxLength"
                                   appOnlyNumbers
                                   [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline"
                                   placeholder="L"/>
                            <input type="text" style="width: 50px !important" disabled [(ngModel)]="s.boxWidth"
                                   appOnlyNumbers
                                   [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline"
                                   placeholder="W"/>
                            <input type="text" style="width: 50px !important" disabled [(ngModel)]="s.boxHeight"
                                   appOnlyNumbers
                                   [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline"
                                   placeholder="H"/>
                          </div>
                        </td>

                        <td><input type="text" disabled [(ngModel)]="s.quantityWeight" class="form-control w-120"
                                   [ngModelOptions]="{standalone: true}" required></td>
                        <td><input type="text" disabled [(ngModel)]="s.totalWeight" class="form-control w-120"
                                   [ngModelOptions]="{standalone: true}" required></td>
                        <td><a (click)="removeShipmentLine(o, s)">
                          <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                            <defs>
                              <style>.a {
                              fill: #848484;
                            }



                            </style>
                            </defs>
                            <path class="a"
                                  d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                                  transform="translate(-7.5 -4.5)"/>
                          </svg>
                        </a></td>
                      </tr>
                    </ng-container>
                  </ng-container>
                  </tbody>
                </table>
              </div>

              <div class="col-md-12" *ngIf="productConfig === 'MULTI_SKU'">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group required">
                      &lt;!&ndash; <input type="text" id="numberOfBoxes" [(ngModel)]="numberOfBoxes" (keyup)="changeBox()" class="form-control" [ngModelOptions]="{standalone: true}" required>
                       <label for="numberOfBoxes" class="control-label">Number Of Boxes</label>&ndash;&gt;
                      <label class="control-label" for="numberOfBoxes">Number Of Boxes</label>
                      <select class="form-control" id="numberOfBoxes" [(ngModel)]="numberOfBoxesM"
                              [ngModelOptions]="{standalone: true}" (change)="changeBox()"
                              [ngModelOptions]="{standalone: true}" required>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="table-3 table-responsive">
                  <table class="table packing-table packing-table-2">
                    <thead class="thead-light">
                    <tr>
                      <th>Product / SKU</th>
                      <th>Shipment Qty</th>
                      <th *ngFor="let b of reviewOrder.lines[0].shipLines; let i=index;">Box {{i + 1}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td colspan="2">Package type</td>
                      <td *ngFor="let b of reviewOrder.lines[0].shipLines">
                        <ng-select id="packagem" class="mt-1" [(ngModel)]="b.packageType" appendTo="body"
                                   (open)="openPackage()"
                                   (click)=selectPackType() (change)="populateDimensions(b)"
                                   [ngModelOptions]="{standalone: true}" required
                                   [items]="package"
                                   bindLabel="packingType"
                                   bindValue="packingType"
                                   placeholder="Package Type" style="width: 220px;">
                        </ng-select>
                        <div class="col-md-12 mt-1">
                          <input type="text" [disabled]="b.packageType !== 'Custom'" appOnlyNumbers
                                 [(ngModel)]="b.boxLength" [ngModelOptions]="{standalone: true}"
                                 class="col-md-3 form-control d-inline" placeholder="L"/>
                          <input type="text" [disabled]="b.packageType !== 'Custom'" appOnlyNumbers
                                 [(ngModel)]="b.boxWidth" [ngModelOptions]="{standalone: true}"
                                 class="col-md-3 form-control mx-1 d-inline" placeholder="W"/>
                          <input type="text" [disabled]="b.packageType !== 'Custom'" appOnlyNumbers
                                 [(ngModel)]="b.boxHeight" [ngModelOptions]="{standalone: true}"
                                 class="col-md-3 form-control d-inline" placeholder="H"/>
                        </div>
                      </td>
                    </tr>
                    <tr *ngFor="let r of reviewOrder.lines">
                      <td>{{r.productName|titlecase}} <br> {{r.sku}}</td>
                      <td>{{r.quantity}} <img src="/./assets/images/tick.svg" class="float-right"
                                              title="Shipment quantity is mathced"
                                              style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;"
                                              *ngIf="showIcon(r)"> <img src="/./assets/images/close.svg"
                                                                        class="float-right"
                                                                        title="Shipment quantity is not mathced"
                                                                        style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;"
                                                                        *ngIf="!showIcon(r) && fieldsEntered(r)"></td>
                      <ng-container *ngFor="let b of r.shipLines">
                        <td *ngIf="b.productId == r.productId">
                          <input type="text" [(ngModel)]="b.quantityPerBox" appOnlyNumbers
                                 [ngModelOptions]="{standalone: true}" class="form-control">
                        </td>
                      </ng-container>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Weight</td>
                      <td></td>
                      <td *ngFor="let b of reviewOrder.lines[0].shipLines">
                        <input type="text" appOnlyNumbers
                               [(ngModel)]="b.singleBoxWeight" [ngModelOptions]="{standalone: true}"
                               (change)="totalWeightCal()"
                               class="form-control d-inline ml-1 w-68" placeholder="Weight" style="width: 72px;"/>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>-->

      <!--<div class="row mt-3" *ngIf="tabClicked == 'selectedProducts'">-->
        <div class="col-12">
          <div class="table-3">
            <table class="table  packing-table-2">
              <thead class="thead-light">
              <tr>
                <th>Product Name</th>
                <th>SKU</th>
                <th>Quantity</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let ol of orderLines">
                <td>{{ol.productName}}</td>
                <td>{{ol.sku}}</td>
                <td>{{ol.returnQuantity}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12 mt-3">
          <label class="text-black"><b>Return Reason :</b><span
            class="ml-1">{{reviewOrder?.returnReason || '--'}}</span></label>
        </div>
      </div>
      <div class="mt-4" *ngIf="tabClicked == 'carrier'">


        <div class="row d-flex justify-content-around">

          <div class="col-md-2 required">
            <div class="form-group">
              <label class="control-label">Approximate Weight (kg)</label>
              <input type="text" id="weight" class="form-control" appOnlyNumbers (blur)="typeWeight()" [ngClass]="{'is-invalid':weightError}" [(ngModel)]="weight" [ngModelOptions]="{standalone: true}" placeholder="Weight" required>
              <div id="weightError"class="invalid-feedback d-block shift-invalid-login" [hidden]="!weightError" style="position: absolute;">{{weightError}}</div>
            </div>
          </div>

          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label">Dimensions(cm)</label>
              <div class="row">
                <div class="col-4">
                  <input type="text" id="l" class="form-control"  (blur)="typeLength()" [ngClass]="{'is-invalid':lengthError}" [(ngModel)]="length" appOnlyNumbers [ngModelOptions]="{standalone: true}" placeholder="L" required>
                  <div id="lengthError"class="invalid-feedback d-block shift-invalid-login" [hidden]="!lengthError" style="position: absolute;">{{lengthError}}</div>
                </div>
                <div class="col-4">
                  <input type="text" id="w" class="form-control"  (blur)="typeWidth()" [ngClass]="{'is-invalid':widthError}" [(ngModel)]="width" appOnlyNumbers [ngModelOptions]="{standalone: true}" placeholder="W" required>
                  <div id="widthError"class="invalid-feedback d-block shift-invalid-login" [hidden]="!widthError" style="position: absolute;">{{widthError}}</div>
                </div>
                <div class="col-4">
                  <input type="text" id="h" class="form-control"  (blur)="typeHeight()" [ngClass]="{'is-invalid':heightError}" [(ngModel)]="height" appOnlyNumbers [ngModelOptions]="{standalone: true}" placeholder="H" required>
                  <div id="heightError"class="invalid-feedback d-block shift-invalid-login" [hidden]="!heightError" style="position: absolute;">{{heightError}}</div>
                </div>

              </div>
            </div>
          </div>


          <div class="col-md-4">

            <button type="button" class="btn btn-orange mt-4" (click)="submitCostEstimation()">Fetch Carrier</button>

          </div>
        </div>



        <!--<div class="row">
          <div class="col-md-12  dip-in">
            <div class="form-radio mr-5">
              <input type="radio" id="shift" [(ngModel)]="order.shippingOption"
                     [ngModelOptions]="{standalone: true}" required value="SHIFT" disabled>
              <label for="shift">Shift</label>
            </div>
            <br><br>
            &lt;!&ndash;<div class="form-radio">
              <input type="radio" id="Regular" [(ngModel)]="order.shippingOption"
                     [ngModelOptions]="{standalone: true}" required value="THIRD_PARTY" disabled>
              <label for="Regular">Third Party Carriers
                <p class="label-para-size">(Shift will chose the cheapest and fastest carrier)</p>
              </label>
            </div>&ndash;&gt;
          </div>
        </div>-->
        <!--<div class="row mt-3">
          <div class="col-md-5">
            <h2 class="text-black mb-3">Shipping Instructions</h2>
              <label  class="mb-1 control-label">{{order.deliveryInstructions|| '&#45;&#45;'}}</label>
          </div>
        </div>-->


        <h2 class="color-3 text-capitalize mt-3 mb-3">Select Your Carrier</h2>
        <div class="mt-3">
          <div class="table-3" style="overflow-x:auto;">
            <table class="table packing-table packing-table-2">
              <thead class="thead-light">
              <tr>
                <th>Select</th>
                <th></th>
                <th>Courier Partner</th>
                <th>Courier Mode</th>
                <th>Price</th>
                <th>Pickup Available</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let o of returnPickupCarrierlist; let i=index;">
                <td>
                  <div class="form-radio">
                    <input type="radio" id="{{i}}" (change)="selectCost(o)" required
                           name="costEstimate">
                    <label for="{{i}}"></label>
                  </div>
                </td>
                <td><img src="assets/images/1-{{o.carrierCode}}.png" style="height: 18px; width: 18px;"></td>
                <td>
                  {{(o.carrierCode == 'SD' ? 'Shift' :
                  (o.carrierCode == 'DL' ? 'Delhivery' :
                  (o.carrierCode == 'GT' ? 'Gati' :
                  (o.carrierCode == 'DZ' ? 'Dotzot' :
                  (o.carrierCode == 'RD' ? 'Rapid Delivery' :
                  (o.carrierCode == 'SF' ? 'Shadow Fax' :
                  (o.carrierCode == 'BD' ? 'Blue Dart' :
                  (o.carrierCode == 'PR' ? 'Pickrr' :
                  (o.carrierCode == 'SY' ? 'Ship Yaari' :
                  (o.carrierCode == 'DE' ? 'Delhivery' :
                  (o.carrierCode == 'SG' ? 'Shippigo' :
                  (o.carrierCode == 'VS' ? 'Vamaship' :
                  (o.carrierCode == 'DN' ? 'Dunzo' :
                  (o.carrierCode == 'WF' ? 'Borzo' :
                  (o.carrierCode == 'XB' ? 'Xpressbees' :
                  (o.carrierCode == 'KE' ? 'Kerry' :
                  (o.carrierCode == 'FE' ? 'FedEx' : o.carrierCode)))))))))))))))))}}
                  <div
                    style="display: inline-flex;">{{o.shippingPreference}}
                  </div>
                </td>
                <td>
                  <!--<div >
                    {{ (o.serviceType || " ") | replaceStatus}}
                  </div>-->
                  <div >{{o.serviceType | replaceStatus}}</div>
                  <div >{{o.deliveryMode | replaceStatus}}</div>
                  <div>{{o.courier}}</div>
                </td>
                <td>{{o.totalAmount | currency:'INR'}}</td>
                <td>{{"Yes"}}</td>
              </tr>
              </tbody>


              <tfoot>
              <tr *ngIf="returnPickupCarrierlist?.length === 0 || !returnPickupCarrierlist?.length">
                <td [attr.colspan]="7" class="text-center">No Carriers available to serve the Order</td>
              </tr>
              </tfoot>
            </table>
            <!--<div class="mt-3 m-3" *ngIf="others == true">
              <div class="row">
                <div class="col-md-4 requred">
                  <div class="form-group">
                    <label class="control-label">Carrier Name</label>
                    <input type="text" id="carrierName" class="form-control" [(ngModel)]="carrierName"
                           [ngModelOptions]="{standalone: true}"
                           (blur)="carrierNameBlur()" [ngClass]="{'is-invalid':carrierNameError}">
                    <div [hidden] = "!carrierNameError" class="invalid-feedback d-block shift-invalid-login" id="carrierNameError">
                      {{carrierNameError}}
                    </div>
                  </div>
                </div>

                <div class="col-md-4 requred">
                  <div class="form-group">
                    <label class="control-label" for="shippedDate">Shipped Date</label>
                    <input type="date" id="shippedDate" class="form-control"packageType
                           [(ngModel)]="shippedDate" [ngModelOptions]="{standalone: true}"
                           (blur)="shippedDateBlur()" [ngClass]="{'is-invalid':shippedDateError}">

                    <div [hidden] = "!shippedDateError" class="invalid-feedback d-block shift-invalid-login" id="shippedDateError">
                      {{shippedDateError}}
                    </div>
                  </div>
                </div>

                <div class="col-md-4 requred">
                  <div class="form-group">
                    <label class="control-label">Shipment Cost</label>
                    <input type="text" id="shipmentCost" class="form-control" [(ngModel)]="shipmentCostOther"
                           [ngModelOptions]="{standalone: true}"
                           (blur)="shipmentCostOtherBlur()" [ngClass]="{'is-invalid':shipmentCostOtherError}">
                    <div [hidden] = "!shipmentCostOtherError" class="invalid-feedback d-block shift-invalid-login" id="shipmentCostOtherError">
                      {{shipmentCostOtherError}}</div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label">AWB Number</label>
                    <input type="text" id="AWBNumber" class="form-control" [(ngModel)]="AWBNumber"
                           [ngModelOptions]="{standalone: true}">
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label" for="deliveryPinCode">Tracking URL</label>
                    <input type="text" id="deliveryPinCode" class="form-control"
                           [(ngModel)]="trackingURL" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>

            </div>-->
          </div>
        </div>



      </div>

      </div>

      <div class=" mt-3">
        <div class=" text-right" *ngIf="tabClicked === 'packing'">
          <!--<button type="reset" (click)="clearFields()" class="btn btn-cancel">Clear</button>-->
          <button type="reset" routerLink="/admin/returns" class="btn btn-cancel">Cancel</button>
          <button type="button" (click)="moveToShipping()"
                  class="btn btn-orange ml-1">Next
          </button>
        </div>
        <div class="m-4 p-4 float-end">
          <button type="submit" (click)="Submit()" *ngIf="tabClicked == 'carrier'" class="btn btn-orange "
                  [disabled]="!reviewOrder?.orderNumber">Submit
          </button>
        </div>
      </div>

    <!--<div *ngIf="tabClicked === 'carrier'">
      <div class="row mt-3">
        <div class="col">
          <div class="inner-box">
            <h2 class="text-black mb-3">Shipping Options</h2>
            <div class="mt-3">
              <div class="table-3" style="overflow-x:auto;">
                <table class="table packing-table packing-table-2">
                  <thead class="thead-light">
                  <tr>
                    <th>Select</th>
                    <th></th>
                    <th>Courier Partner</th>
                    <th>Courier Mode</th>
                    <th>Price</th>
                    <th>Pickup Available</th>
                    <th>Estimated Delivery(in Days)</th>
                  </tr>
                  </thead>
                  <tbody *ngFor="let co of costEstimation; let i=index;">
                  <tr *ngFor="let c of co.costEstimates; let j=index;">
                    <td>
                      <div class="form-radio">
                        <input type="radio" id="cost+{{i}}+{{j}}" (change)="selectCost(c)" required name="costEstimate">
                        <label for="cost+{{i}}+{{j}}"></label>
                      </div>
                    </td>
                    <td><img src="assets/images/1-{{co.carrierCode}}.png" style="height: 18px; width: 18px;"></td>
                    <td>
                      {{(co.carrierCode == 'SD' ? 'Shift' :
                      (co.carrierCode == 'DL' ? 'Delhivery' :
                      (co.carrierCode == 'GT' ? 'Gati' :
                      (co.carrierCode == 'DZ' ? 'Dotzot' :
                      (co.carrierCode == 'RD' ? 'Rapid Delivery' :
                      (co.carrierCode == 'SF' ? 'Shadow Fax' :
                      (co.carrierCode == 'XB' ? 'Xpressbees' :
                      (co.carrierCode == 'KE' ? 'Kerry' :
                      (co.carrierCode == 'FE' ? 'FedEx' : co.carrierCode)))))))))}}
                      <div *ngIf="c.shippingPreference != ''" style="display: inline-flex;" class="ml-2">{{c.shippingPreference}}</div>
                    </td>
                    <td>
                      <div *ngIf="c.deliveryMode && c.serviceType !== null">
                        {{c.deliveryMode + '/' + c.serviceType | replaceStatus}}
                      </div>
                      <div *ngIf="c.serviceType == null">{{c.deliveryMode | replaceStatus}}</div>
                      <div *ngIf="c.deliveryMode == null">{{c.serviceType | replaceStatus}}</div>
                    </td>
                    <td>{{c.totalAmount | currency:'INR'}}</td>
                    <td>{{"Yes"}}</td>
                    <td>{{"1 day"}}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr *ngIf="costEstimation?.length === 0 || !costEstimation?.length">
                    <td [attr.colspan]="7" class="text-center">No Carriers available to serve the Order</td>
                  </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col text-right">
          <button type="reset" (click)="clearFields()" class="btn btn-cancel">Clear</button>
          <button type="submit" (click)="reviewAndConfirm()" class="btn btn-orange ml-2">Next</button>
        </div>
      </div>
    </div>-->
  </form>
  <form *ngIf="step == 2">
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div class="text-center">
            <div name="message" id="errorMessage1" class="invalid-feedback d-block shift-invalid-text"
                 [hidden]="!errorMessage1">{{errorMessage1}}
            </div>
            <h2 class="text-black mb-3 mt-2 review">Review and Confirm</h2>
          </div>
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col-lg-4">
                  <h2 class="text-black mb-2 review">Order Details</h2>
                  <label><b>Order Number :</b><span class="ml-1"></span>{{reviewOrder.orderNumber}}</label><br>
                  <label><b>Create Date :</b><span class="ml-1"></span>{{reviewOrder.orderedDate}}</label>
                </div>
                <div class="col-lg-4">
                  <h2 class="text-black mb-2 review">Sender Details</h2>
                  <label><b>Sender Name :</b><span class="ml-1">{{reviewOrder.senderName}}</span></label><br>
                  <label><b>Sender Address :</b><span class="ml-1">{{reviewOrder.senderAddressText}}</span></label>
                </div>
                <div class="col-lg-4">
                  <h2 class="text-black mb-2 review">Receiver Details</h2>
                  <label class="text-black"><b>Receiver Name :</b><span class="ml-1">{{reviewOrder.receiverName}}</span></label><br>
                  <label><b>Receiver Address :</b><span class="ml-1">{{reviewOrder.receiverAddressText}}</span></label>
                </div>
              </div>
              <hr class="row-bordered">
              <h2 class="text-black mb-2 review">Shipping Details</h2>
              <div class="row">
                <div class="col-lg-4">
                  <label><b>No.of Boxes :</b><span class="ml-1">{{totalBoxes}}</span></label><br/>
                </div>
                <div class="col-lg-4">
                  <label><b>Configuration :</b>
                    <label *ngIf="productConfig == 'SKU'" class="ml-1">One SKU per box</label>
                    <label *ngIf="productConfig == 'MULTI_SKU'" class="ml-1">Multiple SKUs per box</label>
                  </label><br>
                </div>
                <div class="col-lg-4">
                  <label class="text-black mb-2"><b>Shipment Type :</b>
                    <label class="ml-1">{{(shippingCost.carrierCode == 'SD' ? 'Shift' :
                      (shippingCost.carrierCode == 'DL' ? 'Delhivery' :
                      (shippingCost.carrierCode == 'GT' ? 'Gati' :
                      (shippingCost.carrierCode == 'DZ' ? 'Dotzot' :
                      (shippingCost.carrierCode == 'RD' ? 'Rapid Delivery' :
                      (shippingCost.carrierCode == 'SF' ? 'Shadow Fax' :
                      (shippingCost.carrierCode == 'FE' ? 'FedEx' : shippingCost.carrierCode)))))))}}</label>
                  </label>

                </div>
              </div>
              <hr class="row-bordered">
              <div class="row">
                <div class="col">
                  <h2 class="text-black mb-2 review">Product Details</h2>
                  <table class="table">
                    <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Product Name</th>
                      <th>Quantity</th>
                      <th>Quantity Per Box</th>
                      <th>No. of Boxes</th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngFor="let r of reviewOrder.lines;let j=index;">
                      <tr>
                        <td [attr.rowspan]= "(r.shipLines == null ? 1 : r.shipLines.length)" style ="text-transform:uppercase;">{{r.sku}}</td>
                        <td [attr.rowspan]= "(r.shipLines == null ? 1 : r.shipLines.length)">{{r.productName|titlecase}}</td>
                        <td [attr.rowspan]= "(r.shipLines == null ? 1 : r.shipLines.length)">{{r.quantity}}</td>
                        <td>{{(r.shipLines == null ? 0 : r.shipLines[0].quantityPerBox)}}</td>
                        <td>{{(r.shipLines == null ? 0 : r.shipLines[0].numberOfBoxes)}}</td>
                      </tr>
                    </ng-container>
                    <ng-container>
                      <ng-container *ngFor="let r of reviewOrder.lines;let j = index;">
                        <tr *ngFor="let d of r.lineProducts; let x=index;">
                          <td *ngIf="x==0" [attr.rowspan]="(!r.lineProducts.length ? 1 : r.lineProducts.length)"
                          >{{r.sku}}
                          </td>
                          <td *ngIf="x==0"
                              [attr.rowspan]="(!r.lineProducts.length ? 1 : r.lineProducts.length)">
                            {{r.productName|titlecase}}
                          </td>
                          <td *ngIf="x==0"
                              [attr.rowspan]="(!r.lineProducts.length ? 1 : r.lineProducts.length)">{{r.quantity}}
                          </td>
                          <td>{{d?.quantityPerBox}}</td>
                          <td
                            *ngIf="(((x==0 && j==1) || (x==0 && j==0)) && order.productConfig === 'MULTI_SKU') || order.productConfig === 'SKU'"
                            [attr.rowspan]="(order.productConfig === 'MULTI_SKU' && reviewOrder.shipLines.length ? reviewOrder.shipLines.length : 1)">
                            {{d?.numberOfBoxes}}
                          </td>
                        </tr>
                        <ng-container *ngFor="let s of r.shipLines;let i= index;">
                          <tr *ngIf="i != 0">
                            <td>{{s.quantityPerBox}}</td>
                            <td>{{s.numberOfBoxes}}</td>
                          </tr>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
